<ion-toolbar>
	<ion-buttons slot="start" class="back_button">
		<ion-back-button icon="close-outline"></ion-back-button>
	</ion-buttons>

	<ion-title>
		<div class="header_banner">
			<div class="header_wrap">
				<img src="../assets/logo.svg" alt="Logo" class="logo" />
				<h1 class="main-header-title">Duellino</h1>
			</div>
			@if (userIsAuthenticated) {
				<div class="header-actions">
					<div>
						<p>{{ (authUser$ | async)?.credits | currency: 'EUR' : 'symbol' }}</p>
					</div>
					<ion-tab-button tab="notifications">
						<ion-badge color="primary" [hidden]="(notificationBadgeCount$ | async)! < 1">{{
							notificationBadgeCount$ | async
						}}</ion-badge>
						<ion-icon name="notifications-outline"></ion-icon>
					</ion-tab-button>
				</div>
			}
		</div>
	</ion-title>
</ion-toolbar>
